import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { formatDate } from '@angular/common';
import { TuiDayRange } from '@taiga-ui/cdk';
import { TUI_DARK_MODE } from '@taiga-ui/core';
import { TranslateService } from '@ngx-translate/core';
import { LegendItemType } from '@src/app/components/legend';
import { capitalizeFirstLetter } from '@src/utils';
import { MonthStatistics } from '@src/api';

import { LEGEND_ITEMS } from './constants';

@Component({
  selector: 'lp-statistics-bar-chart',
  templateUrl: './lp-statistics-bar-chart.component.html',
  styleUrls: ['./lp-statistics-bar-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpStatisticsBarChartComponent {
  private readonly translateService = inject(TranslateService);
  protected readonly darkMode = inject(TUI_DARK_MODE);

  @Input() set data(value: Array<MonthStatistics> | undefined) {
    this.setData(value);
  }

  @Input() loading = true;

  filter?: TuiDayRange;
  legendItems?: Array<LegendItemType> = LEGEND_ITEMS;

  axisXLabels: Array<string> = [];
  axisYLabels: Array<string> = [];

  values: Array<Array<number>> = [[], [], [], []];
  maxValue = 0;

  get noData() {
    return (
      !this.values?.length ||
      (!this.values[0].length && !this.values[1].length && !this.values[2].length && !this.values[3].length)
    );
  }

  getSetName(index: number): string {
    return this.legendItems?.[index].label || '';
  }

  private getAxisXLabel(date: string) {
    return (
      formatDate(new Date(date), 'LLL yy', this.translateService.currentLang)
        .split(' ')
        .map((value, index) => {
          if (index === 0) {
            value = value.substring(0, 3);
          }

          return capitalizeFirstLetter(value);
        })
        // eslint-disable-next-line
        .join(" '")
    );
  }

  private getAxisYLabels(values: Array<Array<number>>) {
    const uniqueValues = [...new Set(values[0].concat(values[1], values[2], values[3]))];
    const maxValue = Math.max(...uniqueValues);

    if (maxValue < 4) {
      return ['0', String(maxValue)];
    }

    return [
      '0',
      String(Math.floor(maxValue / 4)),
      String(Math.floor(maxValue / 2)),
      String(Math.floor((maxValue / 4) * 3)),
      String(maxValue),
    ];
  }

  private setData(value?: Array<MonthStatistics>) {
    const axisXLabels: Array<string> = [];
    const values: Array<Array<number>> = [[], [], [], []];

    value?.forEach(item => {
      axisXLabels.push(this.getAxisXLabel(item.date || ''));
      values[0].push(item.listCount || 0); // Показы
      values[1].push(item.linksVisitedCount || 0); // Клики
      values[2].push(item.discountsUsedCount || 0); // Скидки
      values[3].push(item.contactsSentCount || 0); // Переданные контакты
    });

    this.axisXLabels = axisXLabels;
    this.axisYLabels = this.getAxisYLabels(values);
    this.values = values;
  }
}
